<script setup lang="ts">
defineProps<{ message: string }>()
</script>

<template>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background: #0f0f0f;
      color: #e5e5e5;
      font-family: system-ui, sans-serif;
      padding: 2rem;
      box-sizing: border-box;
    "
  >
    <div style="max-width: 600px; width: 100%">
      <h1 style="font-size: 1.5rem; font-weight: 600; margin: 0 0 0.75rem">
        Configuration Error
      </h1>
      <p style="margin: 0 0 1.25rem; color: #a3a3a3; line-height: 1.5">
        The application could not start because the client configuration is missing or invalid.
      </p>
      <pre
        style="
          background: #1a1a1a;
          border: 1px solid #333;
          border-radius: 6px;
          padding: 1rem;
          font-size: 0.8rem;
          white-space: pre-wrap;
          word-break: break-word;
          color: #f87171;
          margin: 0 0 1.25rem;
        "
      >{{ message }}</pre>
      <p style="margin: 0; font-size: 0.85rem; color: #737373">
        If you are a developer, ensure <code>public/config.json</code> exists. Copy from
        <code>config.example.json</code>.
      </p>
    </div>
  </div>
</template>
